import { useFirestoreArrayContainsOrderBy } from "../../firebase/useFirestore";
import HomeMultipleBarChart from "../Visualisations/moment/HomeMultipleBarChart";
import QuestionData from "../graphData/QuestionData";
import { useState, useEffect } from "react";
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import ArrowRightAltOutlinedIcon from '@mui/icons-material/ArrowRightAltOutlined';
import Location from "../../hooks/Location"
import { isFlagOff } from '../../helpers/isFlagOn';

const LiveReportEffectData = ({
  effectId,
  startDate,
  endDate,
  graphType,
  colors,
  visibility,
  layout,
  graphColor = {}          // ✅ default to an object
}) => {
  const [visible, setVisible] = useState(0);
  const [printPage, setPrintPage] = useState(false);
  const [openPage, setOpenPage] = useState(false);
  const page = Location()[2];

  const questionnaireFields = useFirestoreArrayContainsOrderBy(
    "QuestionnaireFields",
    "EffectId",
    effectId || "123",
    "IndicatorPosition",
    "asc"
  );

  useEffect(() => {
    if (page === "printlivereport") setPrintPage(true);
    else if (page === "livereportopen") setOpenPage(true);
  }, [page]);

  // ✅ keep visible index in range when data loads/changes
  useEffect(() => {
    setVisible(v => {
      if (!questionnaireFields?.length) return 0;
      return Math.min(v, questionnaireFields.length - 1);
    });
  }, [questionnaireFields?.length]);

  const nextIndicator = () =>
    setVisible(v => (v < questionnaireFields.length - 1 ? v + 1 : 0));
  const previousIndicator = () =>
    setVisible(v => (v > 0 ? v - 1 : questionnaireFields.length - 1));

  const renderIndicator = item => (
    <div
      key={item.ID}
      className="home-kpi-container"
      // Alleen een nadrukkelijk 'uit' verbergt: 319 van de 320 rapportonderdelen
      // hebben helemaal geen Visibility en horen zichtbaar te blijven. Een
      // vergelijking met alleen de tekst "false" liet een boolean `false` als
      // ZICHTBAAR renderen — en dit onderdeel wordt ook in het publieke rapport
      // gebruikt, dus dat faalde de verkeerde kant op.
      // AI-CONTEXT: See docs/pitfalls.md#ui-togglebutton-string-only-branches
      style={{ display: isFlagOff(visibility) ? "none" : "block" }}
    >
      <QuestionData
        indicator={item}
        startDate={startDate}
        endDate={endDate}
        docid={item.docid}
        paragrapgMomentVisibilityStyle={item.ParagraphMomentVisibilityStyle}
        graphType={graphType}
        fieldType={item.Type}
        liveReportHidden={item.LiveReportHidden}
        colors={colors}
        effectId={effectId}
        graphColor={graphColor}
      />
    </div>
  );

  if (questionnaireFields.length === 0) {
    return <HomeMultipleBarChart field={[{ ID: "123" }]} moment={"123"} />;
  }

  if (layout === "under") {
    return <>{questionnaireFields.map(renderIndicator)}</>;
  }

  // ✅ safe current field & color
  const currentField = questionnaireFields[visible] ?? questionnaireFields[0];
  const currentColor = graphColor?.[currentField?.ID] ?? 'black';

  return (
    <>
      {!printPage && !openPage && (
        <div id="live-report-effect-indicator-navbar" style={{ display: "flex" }}>
          <div
            className="live-report-effect-indicator-navbar-button-container"
            onClick={previousIndicator}
          >
            <KeyboardBackspaceOutlinedIcon style={{ fill: currentColor }} />
            <p style={{ color: currentColor }} className="live-report-effect-indicator-navbar-button">
              Vorige
            </p>
          </div>

          <div>
            <p style={{ color: currentColor }}>
              {visible + 1} van de {questionnaireFields.length}
            </p>
          </div>

          <div
            className="live-report-effect-indicator-navbar-button-container"
            onClick={nextIndicator}
          >
            <p style={{ color: currentColor }} className="live-report-effect-indicator-navbar-button">
              Volgende
            </p>
            <ArrowRightAltOutlinedIcon style={{ fill: currentColor }} />
          </div>
        </div>
      )}

      {currentField && renderIndicator(currentField)}
    </>
  );
};


export default LiveReportEffectData

  